import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { usePageMeta } from '@/lib/seo';
import { PAGES } from '@/seo/pages';

export function NotFoundPage() {
  usePageMeta(PAGES.notFound);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center justify-center py-24 text-center">
      <p className="font-mono text-6xl font-bold text-primary">404</p>
      <h1 className="mt-4 text-xl font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        The page you are looking for does not exist or has moved.
      </p>
      {/* `/` rather than the dashboard: this also renders for an unknown documentation page, where
          the visitor may not be signed in. Signed-in visitors are sent on from `/` anyway. */}
      <Button asChild className="mt-6">
        <Link to="/">Go to the home page</Link>
      </Button>
    </div>
  );
}
